export * from './iframe-dm-dance-courses-page.component';
export * from './iframe-dm-dance-courses-page.module';
